<div *ngIf="field.frontendLabel!='Price' && field.frontendLabel!='Discount Percentage' 
 && field.frontendLabel!='Weight'">
  <div *ngIf="!field.frontendLabel.includes('Whole Sale')">
    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>

      <input [attr.guide]="'price-inp-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        matInput [formControlName]="field.attributeCode" numbersOnly/>
      <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
      </div>
      <mat-hint fxHide.lt-md *ngIf="field.frontendLabel=='Weight'">Product Weight Should be Mentioned in
        Grams</mat-hint>
    </mat-form-field>

  </div>
</div>

<div *ngIf="field.frontendLabel=='Weight'">
  <div>
    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}} </mat-label>
      <input [attr.guide]="'price-inp-2' + '__' + sanitizeUrl(url)" (blur)="priceUpdate($event)" [autocomplete]="'off'"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false" matInput
        [formControlName]="field.attributeCode" numbersOnly/>
      <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
      </div>
      <mat-hint fxHide.lt-md *ngIf="field.frontendLabel=='Weight'">Product Weight Should be Mentioned in
        Grams</mat-hint>
    </mat-form-field>

  </div>
</div>


<div *ngIf="field.frontendLabel.includes('Whole Sale')&&b2bPricingEnabled">
  <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{field.frontendLabel}}</mat-label>

    <input [attr.guide]="'price-inp-3' + '__' + sanitizeUrl(url)" type="tel" [autocomplete]="'off'"
      [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false" matInput
      [formControlName]="field.attributeCode" numbersOnly pattern="[0-9]*" inputmode="numeric"/>
    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>
    <mat-hint fxHide.lt-md *ngIf="field.frontendLabel=='Weight'">Product Weight Should be Mentioned in Grams</mat-hint>
  </mat-form-field>

</div>

<div *ngIf="field.frontendLabel=='Price'|| field.frontendLabel=='Discount Percentage'">

  <div *ngIf="field.frontendLabel=='Price'">


    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>

      <input [attr.guide]="'price-inp-4' + '__' + sanitizeUrl(url)" (blur)="getSpecialPrice()" [autocomplete]="'off'"
        [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false" matInput
        [formControlName]="field.attributeCode" numbersOnly/>
      <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
      </div>
    </mat-form-field>
  </div>
  <div *ngIf="field.frontendLabel=='Discount Percentage'">
    <mat-form-field fxFlex.gt-md="60" fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{field.frontendLabel}}</mat-label>
      <input [attr.guide]="'price-inp-5' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" [required]="group.controls[field.attributeCode].status == 'INVALID' ? true : false"
        matInput [formControlName]="field.attributeCode" numbersOnly/>
      <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
      </div>
    </mat-form-field>

  </div>
</div>


<ng-template #special>

  <div class="index-head">
    <span>Special Discount in Percent</span>
  </div>

  <form [formGroup]="thirdFormGroup">
    <div class="padding-10">

      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
          <mat-label>Special Price Discount</mat-label>
          <input [attr.guide]="'price-inp-specialdiscount' + '__' + sanitizeUrl(url)" matInput formControlName="specialDiscount"/>
        </mat-form-field>
      </div>
    </div>
  </form>
  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button [attr.guide]="'price-btn-6' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close tabindex="-1">Cancel</button>
    <button [attr.guide]="'price-btn-7' + '__' + sanitizeUrl(url)" [disabled]="textAccount !='OK'" (click)=" submit2()" mat-raised-button>
      {{textAccount}}
      <mat-icon *ngIf="textAccount !='OK' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon></button>
  </div>
</ng-template>